import { useState, useContext } from "react";
// import "./style.scss";
import "./style-rtl.scss";
import Header from "../SharedComponents/Header";
import Navbar from "../SharedComponents/Navbar";
import { ReactComponent as UploadIcon } from "../assets/icons/uploadIcon.svg";
import Score from "../SharedComponents/Score";
import ButtonPrimary from "../SharedComponents/ButtonPrimary";
import { useParams, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { useTranslation } from "react-i18next";
import { scrollIntoView, toBase64 } from "../helperFunctions";
import { sendFeedbackPost } from "../universalData";
import Store from "../Store";
import { postAjax } from "../axiosMethods";
import { resizeBase64Img } from "../Rating/Dependencies";
import GlobalStates from "../../layouts/GlobalStates";
import { GlobalStateContext } from "./../../layouts/GlobalStates";
import ButtonSecondary from "./../SharedComponents/ButtonSecondary/index";
import DBButton from "../../component/global/DBButton";
import DBInput from "../../component/global/DBInput";
import DBTextArea from "../../component/global/DBTextArea";
import DBUpload from "./../../component/global/DBUpload/index";
import FinalResultModal from "./Modal";
import {
    RewardBadge,
    RewardStatus,
} from "../../features/incentives/Rewards";

export default function More() {
    const { id } = useParams();
    const { t, i18n } = useTranslation();
    const { feedbackAppGlobalState } = useContext(GlobalStateContext);
    const [result, setResult] = feedbackAppGlobalState;

    const [loader, setLoader] = useState(false);

    const [title, setTitle] = useState("");
    const [titleErr, setTitleErr] = useState("");

    const [body, setBody] = useState("");
    const [bodyErr, setBodyErr] = useState("");

    const [file, setFile] = useState(undefined);
    // const [fileSize, setFileSize] = useState(0);
    const [fileName, setFileName] = useState("");
    const [fileType, setFileType] = useState("");
    const [fileErr, setFileErr] = useState("");
    const [copied, setCopied] = useState(false);
    const navigate = useNavigate();

    const sendFeedback = () => {
        let hasErr = false;
        setTitleErr("");
        setBodyErr("");
        setFileErr("");

        if (title === "") {
            setTitleErr(t("title.empty"));
            hasErr = true;
        }
        if (body === "") {
            setBodyErr(t("body.empty"));
            hasErr = true;
        }
        // if(fileSize > 2){
        //     setFileErr(t("file.size.exceed"));
        //     hasErr = true;
        // }
        if (file && fileType.split("/")[0] !== "image") {
            setFileErr(t("file.type"));
            hasErr = true;
        }
        if (hasErr) return false;
        setLoader(true);
        postAjax(sendFeedbackPost, {
            item: result.data.item,
            user: result.username || window.sessionStorage.getItem("username"),
            name: title,
            file,
            description: body,
        })
            .then((e) => {
                setFile(undefined);
                setTitle("");
                setBody("");
                setFileName("");

                // setFileSize(0);
                setCopied(true);
                // setTimeout((_) => setCopied(false), 2000);
            })
            .catch((_) => {
                setCopied(t("feedback.fail"));
            })
            .finally((_) => {
                setLoader(false);
            });
    };

    const getFileHandle = async (e) => {
        if (e.target.value) {
            let base64 = await toBase64(e.target.files[0]);
            base64 = await resizeBase64Img(base64, 1200);
            setFile(base64);
            // setFileSize(e.target.files[0].size / 1024 / 1024);
            setFileType(e.target.files[0].type);
            setFileName(e.target.files[0].name);
        } else {
            setFile(undefined);
            setFileName("");
            e.target.value = "";
        }
    };

    return (
        <div className="main-container">
            {copied === true && (
                <RewardStatus
                    action="offer"
                    targetType="item"
                    targetId={result.data.item}
                />
            )}
            {sessionStorage.getItem("username") || result.username ? (
                !copied ? (
                    <div className="more">
                        <div className="participation-title-row">
                            <h2>{t("feedback.title")}</h2>
                            <RewardBadge
                                action="offer"
                                targetType="item"
                                targetId={result.data.item}
                                opportunity={
                                    result.ajax?.incentive_opportunities?.offer
                                }
                            />
                        </div>
                        <div
                            className={
                                "input-section" + (titleErr ? " err" : "")
                            }
                        >
                            <DBInput
                                status={titleErr && "error"}
                                size="large"
                                type="text"
                                placeholder={t("feedback.title.placeholder")}
                                onChange={(e) => setTitle(e.target.value)}
                                value={title}
                                onClick={() => setTitleErr("")}
                            />
                        </div>
                        {titleErr && (
                            <span className="err-field">{titleErr}</span>
                        )}

                        {/* <label
                        className={"input-section" + (fileErr ? " err" : "")}
                    >
                        <span>{fileName || t("tap.here")}</span>
                        <input
                            id="upload"
                            type="file"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={getFileHandle}
                        />
                        <div className="button">
                            <UploadIcon />
                        </div>
                    </label> */}

                        <h2>{t("feedback.body")}</h2>
                        <DBTextArea
                            status={bodyErr && "error"}
                            placeholder={t("feedback.body.placeholder")}
                            className={bodyErr ? " err" : ""}
                            value={body}
                            onChange={(e) => setBody(e.target.value)}
                            onClick={() => setBodyErr("")}
                        />

                        {bodyErr && (
                            <span className="err-field">{bodyErr}</span>
                        )}
                        <h2>{t("feedback.image")}</h2>
                        <DBUpload
                            accept=".jpg,.png"
                            maxSize={1024 * 1024}
                            outlined
                            caption="آپلود تصویر"
                        />
                        {/* <Score size="big" score={4} title={true}/> */}
                        <DBButton
                            caption={
                                loader ? (
                                    <ClipLoader
                                        color="white"
                                        loading={true}
                                        size={30}
                                    />
                                ) : (
                                    t("feedback.send")
                                )
                            }
                            onClick={sendFeedback}
                        />
                        <div
                            className={
                                "floating-notification" +
                                (copied ? " show" : "")
                            }
                        >
                            {copied}
                        </div>
                    </div>
                ) : (
                    <FinalResultModal />
                )
            ) : (
                <div className="more no-access">
                    {t("more.no.access")}
                    <div>
                        <ButtonPrimary
                            btnContent={t("send.Feedback.label")}
                            onClick={() => navigate("/feedback/form/" + id)}
                        />
                        <ButtonSecondary
                            btnContent={
                                t("LogIn.Button") + " / " + t("SignUp.Tab")
                            }
                            onClick={() =>
                                navigate("/auth", {
                                    state: {
                                        from: `/feedback/more/${id}`,
                                    },
                                })
                            }
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
